import { render, staticRenderFns } from "./BadgeButton.vue?vue&type=template&id=3fbd1eb1&"
import script from "./BadgeButton.vue?vue&type=script&lang=js&"
export * from "./BadgeButton.vue?vue&type=script&lang=js&"
import style0 from "./BadgeButton.vue?vue&type=style&index=0&id=3fbd1eb1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports